module.exports = __webpack_public_path__ + "static/media/ic-new-contribution.8f9df895.svg";